import * as Yup from 'yup';

import { makeStyles } from 'tss-react/mui';
import { OrgManager, patchUserProfile } from '@uplift/api';
import { TextInput } from '@uplift/ui-v2';

import { useEditManagerProfileHandlers } from '../hooks';

export type ManagerTitleFormType = {
  title: string | null;
};

export const useManagerTitleForm = (managerData: OrgManager, title) => {
  const managerId = managerData?.user?.id;

  const { onFormSubmitSuccess, onFormSubmitError } = useEditManagerProfileHandlers(managerId, 'Job Title');

  const managerTitleFormik = () => {

    const initialValues: ManagerTitleFormType = {
      title: title || '',
    };

    const validationSchema = Yup.object({
      title: Yup.string()
        .default('')
        .test('not-only-spaces', 'Title cannot be only spaces', (value) => {
          if (value === '') {
            return true;
          }
          return value?.trim().length > 0;
        }),
    });

    const onSubmit = async (values: ManagerTitleFormType) => {
      try {
        await patchUserProfile(managerId, {
          title: values.title,
        });
        await onFormSubmitSuccess(true);
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { managerTitleFormik };
};

export const ManagerTitleForm: React.VFC = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.formGroup}>
      <TextInput
        label="Job Title"
        name="title"
        fullWidth
        className={classes.input}
        data-testid="manager-title-input"
      />
    </div>
  );
};

export const useStyles = makeStyles()((theme) => ({
  input: {
    '& label.Mui-focused': {
      color: theme.palette.secondary.main,
    },
    '& .Mui-checked': {
      color: theme.palette.secondary.main,
    },
    '& .Mui-focused:not(.Mui-error) fieldset': {
      borderColor: theme.palette.secondary.main,
    },
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    maxWidth: '400px'
  },
}));
